/* src/app/views/template/components/edit-template-menu/edit-template-card-stack-menu/edit-template-card-stack-menu-header/edit-template-card-stack-menu-header.component.scss */
.card-stack-template-secondary-header {
  display: flex;
  flex-direction: row;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f2f2f2;
}
.card-stack-template-left-side-of-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;
}
.card-stack-template-right-side-of-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}
/*# sourceMappingURL=edit-template-card-stack-menu-header.component.css.map */
